// API helper for Klinik Acu-sense CMS integration

const BASE_URL = 'https://api.dev.auxo.dk/public';

// Fallback mock data matching the seeded CMS content exactly
export const FALLBACK_PAGES = [
  {
    title: "Velkommen til Klinik Acu-sense | ",
    page_slug: "index",
    meta_title: "Velkommen til Klinik Acu-sense | Akupunktur i Hammel",
    meta_description: "Klinik Acu-sense i Hammel tilbyder professionel akupunktur ved RAB-godkendt akupunktør Brian Hangaard. Få hjælp til smerter, migræne, søvnproblemer og allergi.",
    markdown_content: `
      <p><img src="https://assets.auxodev.dk/assets/2c4bccc2-b14e-4d92-a991-09327bae6f21/91ef7221-010c-4281-b8d0-6e03f8b95382.webp" alt="Brian Hangaard - Klinik Acu-sense" /></p>
      <p>Velkommen til Klinik Acu-sense</p>
      <p>Mit navn er Brian Hangaard.</p>
      <p>Jeg er uddannet akupunktør (RAB godkendt) og fysioterapeut.</p>
      <p>Som uddannet akupunktør kan jeg behandle en lang række tilstande, symptomer og lidelser.</p>
      <p>Mit specialer er smertebehandling, hovedpine, migræne, søvnforstyrrelser, fordøjelsesproblematikker og hedeture/overgangsalder.</p>
      <p>Jeg behandler dine symptomer, men også årsagen til dine ubalancer.</p>
      <p>Behandlingen genskaber balancen og energien i din krop, så du ex kan vende tilbage til dit arbejde, genoptage din fritidsinteresse, få mere energi i hverdagen eller noget helt fjerde.</p>
      <p><a href="https://system.easypractice.net/book/akupunktur-klinikken-acu-sense">Book tid</a></p>
      <h2>Spørgsmål jeg ofte får i klinikken</h2>
      <h3>Kan jeg hjælpe dig?</h3>
      <p>Vores krop kan komme i ubalance og have brug for hjælp til at starte en helingsproces.</p>
      <p>Jeg har en stor overbevisning om, at kroppen som udgangspunkt er stærk og vil gøre hvad den kan for at kompensere for ubalancer.</p>
      <p>Jeg ser og behandler kroppen som en helhed og ikke kun dine ex knæsmerter eller forstoppelse.</p>
      <p>Længerevarende symptomer er ofte et tegn på en bagvedliggende årsag.</p>
      <h3>Hvor mange behandlinger skal der til?</h3>
      <p>Det er ingen hurtige genveje til et godt resultat.</p>
      <p>Et behandlingsforløb er en rigtig god mulighed for at følge dine symptomer til dørs samtidig med, at årsagen til dine problematikker bliver behandlet.</p>
      <p>Behandlingsforløbet bliver tilrettelagt individuelt.</p>
      <p>Flere faktorer kan påvirke antallet af behandlinger for at nå vores fælles aftalte mål fx:</p>
      <ul>
        <li>hvor lang tid du har haft dine symptomer</li>
        <li>hvilke symptomer er til stede</li>
        <li>er der flere ubalancer på samme tid</li>
        <li>hvad er energiniveauet i kroppen.</li>
      </ul>
      <p>Et behandlingsforløb kan have positive og negative udsving. Det er en hel normal reaktion, der viser, at kroppen er i forandring.</p>
      <h3>Hvor ofte skal du have en behandling?</h3>
      <p>Kommer du med smerter kan det være en fordel at behandle min. 2 gange om ugen for at bryde de ubalancer, smerten har skabt i kroppen. Hyppige behandlinger vil forhindre, at kroppen når at ”falde” tilbage til det gamle mønster.</p>
      <p>Ved tilstande som for eksempel langvarige muskel-/nervesmerter, migræne, søvnproblematikker, stress eller depression bliver der sat gang i en dybere proces i kroppen.</p>
      <p>For at imødekomme processen, bliver behandlingsfrekvensen aftalt individuelt.</p>
    `,
    images: ["https://assets.auxodev.dk/assets/2c4bccc2-b14e-4d92-a991-09327bae6f21/91ef7221-010c-4281-b8d0-6e03f8b95382.webp"]
  },
  {
    title: "Hvad kan jeg hjælpe med | ",
    page_slug: "om",
    meta_title: "Hvad kan jeg hjælpe med | Klinik Acu-sense",
    meta_description: "Se, hvad Klinik Acu-sense kan hjælpe dig med. Jeg tilbyder Seizen Hari, akupunktur, øreakupunktur (Auriculo) og posturologi for smerter, allergi og meget mere.",
    markdown_content: `
      <p><img src="https://assets.auxodev.dk/assets/2c4bccc2-b14e-4d92-a991-09327bae6f21/c9b695e4-28b7-4bf4-8745-14a1efd7932e.webp" alt="Behandling" /></p>
      <p>Akupunktur er særdeles effektiv til en række tilstande, symptomer og lidelser.</p>
      <p>Jeg har behandlingserfaring med:</p>
      <ul>
        <li>Smerter i kroppen
          <ul>
            <li>Nakke og kæbe</li>
            <li>Skuldre</li>
            <li>Albue</li>
            <li>Ryg og lænd</li>
            <li>Bækken</li>
            <li>Knæ</li>
            <li>Fødder</li>
          </ul>
        </li>
        <li>Hovedpine og migræne</li>
        <li>Fordøjelsesproblemer</li>
        <li>Søvnproblematikker</li>
        <li>Hedeture/overgangsalder</li>
        <li>Menustrationsmerter</li>
        <li>Senfølger efter hjernerystelse</li>
        <li>Allergi</li>
        <li>Svimmelhed</li>
      </ul>
      <p>Nederst på siden kan du se et uddrag af World Health Organizations (WHO) liste over sygdomme/symptomer, som akupunktur har virkning på.</p>
      <p><a href="https://system.easypractice.net/book/akupunktur-klinikken-acu-sense">Book tid</a></p>
    `,
    images: [
      "https://assets.auxodev.dk/assets/2c4bccc2-b14e-4d92-a991-09327bae6f21/c9b695e4-28b7-4bf4-8745-14a1efd7932e.webp",
      "https://assets.auxodev.dk/assets/2c4bccc2-b14e-4d92-a991-09327bae6f21/22108187-2392-4517-9a2f-8a5b1c94289f.webp",
      "https://assets.auxodev.dk/assets/2c4bccc2-b14e-4d92-a991-09327bae6f21/6d09ead8-696a-4e79-9bad-a6e1ed569d35.webp",
      "https://assets.auxodev.dk/assets/2c4bccc2-b14e-4d92-a991-09327bae6f21/413354c9-e6fd-450c-a18d-f94ed306ece1.webp",
      "https://assets.auxodev.dk/assets/2c4bccc2-b14e-4d92-a991-09327bae6f21/38f5af53-aeba-4783-8bfc-ad30b459a880.webp"
    ]
  },
  {
    title: "Priser | ",
    page_slug: "om111",
    meta_title: "Priser | Klinik Acu-sense",
    meta_description: "Se priser for akupunkturbehandlinger hos Klinik Acu-sense i Hammel. Mulighed for tilskud fra Sygeforsikringen 'danmark' og sundhedsforsikringer.",
    markdown_content: `
      <h1>Priser pr. 1. januar 2026</h1>
      <p>Første behandling kr. 450,00</p>
      <p>Efterfølgende behandlinger kr. 550,00</p>
      <p>Klippekort (5 behandlinger) kr. 2.500,00</p>
      <p>Behandling for myg kr. 150,00</p>
      <p>Der er tilskud fra Sygeforsikringen "danmark".</p>
      <p>Jeg er RAB godkendt, så du kan bruge din sundhedsforsikring.</p>
    `,
    images: ["https://assets.auxodev.dk/assets/2c4bccc2-b14e-4d92-a991-09327bae6f21/3c35f7cd-14a5-431c-9e61-3582fad6e704.webp"]
  },
  {
    title: "Opslagstavle | ",
    page_slug: "kontakt1",
    meta_title: "Opslagstavle | Klinik Acu-sense",
    meta_description: "Aktuelle tilbud og sæsonbehandlinger hos Klinik Acu-sense. Læs om effektiv allergibehandling og myggebehandling i Hammel.",
    markdown_content: `
      <h1>Allergibehandling - begynd allerede behandlingen i det tidlige forår</h1>
      <p>Jeg har gode resultater med at lindre eller helt fjerne de symptomer, der er ved allergi af forskellig art.</p>
      <p>Pris pr. behandling kr. 550,00 kr</p>
      <p><strong>4 behandlinger for 2.000,00 kr.</strong></p>
      <p>Typisk er det 3-4 behandlinger med en uges mellemrum. Der kan være behov for flere behandlinger, hvis du er hårdt ramt.</p>
      <h2>Myggebehandling</h2>
      <p>Pris pr. behandling kr. 150,00</p>
      <p>Typisk er der ret god effekt af behandlingen allerede efter første behandling. Der kan være behov for flere behandlinger, hvis myggene stadig ikke kan lade dig være.</p>
    `,
    images: []
  },
  {
    title: "Online booking | ",
    page_slug: "online-booking",
    meta_title: "Online booking | Klinik Acu-sense",
    meta_description: "Book din tid online til akupunkturbehandling hos Klinik Acu-sense i Hammel. Nem og hurtig tidsbestilling.",
    markdown_content: `
      <p>Book tid online hos Klinik Acu-sense.</p>
      <p><strong>Åbningstider i klinikken</strong></p>
      <p>Mandag 8.00 - 19.00</p>
      <p>Tirsdag 8.00 - 17.00</p>
      <p>Onsdag 8.00 - 17.00</p>
      <p>Torsdag 8.00 - 19.00</p>
      <p>Fredag 8.00 - 15.00</p>
      <p>Akupunktur Klinikken Acu-sense</p>
      <p>Banealle 8F, 8450 Hammel</p>
      <p>Telefon: +45 20 45 65 63</p>
    `,
    images: []
  },
  {
    title: "Kontakt |  ",
    page_slug: "kontakt",
    meta_title: "Kontakt | Klinik Acu-sense",
    meta_description: "Kontakt Klinik Acu-sense i Hammel. Find adresse, telefonnummer, e-mail og rutevejledning her. Bestil tid online.",
    markdown_content: `
      <h1>Klinik Acu-sense</h1>
      <p><strong>Adresse</strong></p>
      <p>Banealle 8F</p>
      <p>8450 Hammel</p>
      <p><strong>Telefon</strong></p>
      <p><a href="tel:20456563">20456563</a></p>
      <p><strong>E-mail</strong></p>
      <p><a href="mailto:info@acu-sense.dk">info@acu-sense.dk</a></p>
      <p>Tager jeg ikke telefonen, så læg meget gerne en besked eller send sms, og jeg vil snarest muligt kontakte dig. Der er gode parkeringsforhold og adgang for gangbesværede og kørestole.</p>
    `,
    images: []
  }
];

export const FALLBACK_TREATMENTS = [
  {
    title: "Seizen Hari",
    slug: "seizen-hari",
    description: `
      <p>Seizen Hari er en traditionel japansk meridianterapi, der adskiller sig markant fra klassisk akupunktur ved at være fuldstændig smertefri og uden indstik af nåle. Denne behandlingsform er særdeles velegnet til sensitive personer, børn eller dem, der har nåleskræk, men som stadig ønsker akupunkturens dybe, balancerende virkning.</p>
      <p>Behandlingen tager udgangspunkt i en grundig diagnose, hvorefter behandleren mærker på din mave (hara-diagnose), dine underarme, underben samt din puls. Ud fra denne kortlægning af kroppens energitilstand holdes en speciel, klassisk nål af guld, sølv eller titanium blidt mod udvalgte akupunkturpunkter på hudens overflade. Dette stimulerer kroppens energibaner (meridianer) og genopretter den naturlige balance og vitale energi uden at bryde hudbarrieren.</p>
      <p>Seizen Hari understøtter kroppens selvhelbredende kræfter, dæmper stress, forbedrer søvnen og skaber en dyb følelse af ro og velvære i hele organismen.</p>
    `,
    image: ["https://assets.auxodev.dk/assets/2c4bccc2-b14e-4d92-a991-09327bae6f21/22108187-2392-4517-9a2f-8a5b1c94289f.webp"],
    video: "https://assets.auxodev.dk/assets/2c4bccc2-b14e-4d92-a991-09327bae6f21/knae.mp4",
    is_seasonal: false,
    price: "550,00 kr. (Første behandling: 450,00 kr.)"
  },
  {
    title: "Akupunktur",
    slug: "akupunktur",
    description: `
      <p>Klassisk akupunktur er en anerkendt og dybdegående behandlingsform baseret på traditionel kinesisk medicin (TCM), hvor der anvendes ultratynde, sterile engangsnåle. Behandlingen har til formål at genoprette kroppens naturlige energibalance og stimulere dens egne helingsprocesser.</p>
      <p>Når nålene nænsomt føres ind i specifikke akupunkturpunkter, frigives der endorfiner og andre signalstoffer i nervesystemet. Dette øger blodcirkulationen, dæmper inflammation og reducerer smerte. Akupunktur behandler ikke blot det enkelte symptom, men ser på mennesket som en helhed for at finde og rette op på de bagvedliggende årsager til ubalancer.</p>
      <p>Behandlingen er særdeles effektiv mod en lang række tilstande, herunder kroniske og akutte smerter i ryg, nakke og led, hovedpine, migræne, fordøjelsesproblemer, søvnforstyrrelser samt stress og hormonelle ubalancer som hedeture i overgangsalderen.</p>
    `,
    image: ["https://assets.auxodev.dk/assets/2c4bccc2-b14e-4d92-a991-09327bae6f21/6d09ead8-696a-4e79-9bad-a6e1ed569d35.webp"],
    is_seasonal: false,
    price: "550,00 kr. (Første behandling: 450,00 kr.)"
  },
  {
    title: "Øreakupunktur",
    slug: "oereakupunktur",
    description: `
      <p>Øreakupunktur er en effektiv og hurtigtvirkende behandlingsform, som bygger på princippet om, at hele menneskekroppen og dens organer er afspejlet som et præcist mikrosystem i øret. Når der opstår ubalance eller smerte i en bestemt del af kroppen, vil det tilsvarende punkt i øret blive ømt og modtageligt for behandling.</p>
      <p>Under behandlingen stimuleres disse punkter ved hjælp af fine akupunktur nåle eller små, diskrete magnetkugler, som klistres på øret med et lille plaster. Magnetkuglerne giver dig mulighed for selv at stimulere punkterne løbende mellem behandlingerne ved et let tryk, hvilket forlænger og forstærker effekten.</p>
      <p>Øreakupunktur anvendes ofte som et stærkt supplement til kropsakupunktur, men kan også stå alene. Det er særdeles velegnet til smertebehandling, stresslindring, søvnproblemer, appetitregulering og som støtte ved afvænning eller følelsesmæssig uro.</p>
    `,
    image: ["https://assets.auxodev.dk/assets/2c4bccc2-b14e-4d92-a991-09327bae6f21/413354c9-e6fd-450c-a18d-f94ed306ece1.webp"],
    is_seasonal: false,
    price: "550,00 kr. (Første behandling: 450,00 kr.)"
  },
  {
    title: "Auriculo",
    slug: "auriculo",
    description: `
      <p>Auriculoterapi (fransk øreakupunktur) er en moderne, videnskabeligt funderet behandlingsmetode udviklet af den franske læge Dr. Paul Nogier. Metoden kortlægger nervesystemets refleksforbindelser i øret og anvender avancerede redskaber to at diagnosticere og behandle ubalancer i kroppen.</p>
      <p>Udover traditionelle nåle og magnetkugler inddrager auriculoterapien moderne teknologi som farvet lys og specifikke frekvensbehandlinger. Ved at belyse ørets reflekszoner med bestemte lysfrekvenser sendes der direkte signaler via nervesystemet til hjernen, som hjælper med at regulere smerter, inflammation og dysfunktioner i de tilsvarende organer eller kropsdele.</p>
      <p>Auriculoterapi er særdeles effektiv til præcis smertebehandling, neurologiske forstyrrelser, funktionelle lidelser samt til at dæmpe stress og genoprette nervesystemets naturlige balance.</p>
    `,
    image: ["https://assets.auxodev.dk/assets/2c4bccc2-b14e-4d92-a991-09327bae6f21/413354c9-e6fd-450c-a18d-f94ed306ece1.webp"],
    is_seasonal: false,
    price: "550,00 kr. (Første behandling: 450,00 kr.)"
  },
  {
    title: "Posturologi",
    slug: "posturologi",
    description: `
      <p>Posturologi er læren om kroppens stående balance og holdning. Vores evne til at stå oprejst uden smerter afhænger af, at hjernen modtager korrekte og synkroniserede informationer fra kroppens primære sanseapparater – herunder øjnene, fødderne, bidfunktion/kæbe samt det indre øre.</p>
      <p>Hvis der opstår en fejlregulering i et af disse systemer (f.eks. en lille skævhed i fødderne eller en ubalance i øjenmuskulaturen), vil hjernen kompensere ved at spænde uhensigtsmæssigt op i kroppens muskler. Dette fører til skævheder i bækken, ryg og nakke, hvilket over tid kan forårsage tilbagevendende eller kroniske smerter, spændingshovedpine og svimmelhed.</p>
      <p>Gennem posturologisk undersøgelse lokaliseres årsagen til skævheden, og balancen genoprettes nænsomt ved hjælp af specifikke øreakupunkturpunkter. Behandlingen fjerner selve årsagen til de kroniske spændinger, så kroppen kan finde tilbage til sin naturlige, smertefrie holdning.</p>
    `,
    image: ["https://assets.auxodev.dk/assets/2c4bccc2-b14e-4d92-a991-09327bae6f21/20230518-102713_1.jpg"],
    is_seasonal: false,
    price: "550,00 kr. (Første behandling: 450,00 kr.)"
  },
  {
    title: "Allergi behandling",
    slug: "allergi-behandling",
    description: `
      <p>Allergi og høfeber kan være en stor belastning i hverdagen, men med målrettet akupunktur kan du lindre eller helt fjerne de generende symptomer som nysen, kløende øjne, tilstoppet næse og træthed.</p>
      <p>Behandlingen virker ved at regulere og berolige et overreaktivt immunforsvar samt dæmpe den inflammatoriske respons i slimhinderne. For at opnå den absolut bedste effekt anbefales det at påbegynde behandlingen i det tidlige forår, inden pollensæsonen for alvor sætter ind, men akupunkturen kan også lindre effektivt midt i sæsonen.</p>
      <p>Et typisk forløb består af 3-4 behandlinger med en uges mellemrum. Hvis du er meget hårdt ramt, kan der være behov for enkelte opfølgende behandlinger for at holde symptomerne nede og sikre dig en rolig og behagelig sæson.</p>
    `,
    image: ["https://assets.auxodev.dk/assets/2c4bccc2-b14e-4d92-a991-09327bae6f21/c9b695e4-28b7-4bf4-8745-14a1efd7932e.webp"],
    is_seasonal: true,
    price: "550,00 kr. (4 behandlinger for 2.000,00 kr.)"
  },
  {
    title: "Myggestik behandling",
    slug: "myggestik-behandling",
    description: `
      <p>Er du en af dem, som myggene altid går efter, og oplever du store, kløende og hævede reaktioner efter myggestik? Klinik Acu-sense tilbyder en yderst effektiv og hurtig akupunkturbehandling, der ændrer kroppens reaktion, så myggene lader dig være i fred, eller så stikkene ikke længere hæver op og klør.</p>
      <p>Behandlingen er smertefri og tager kun 15 minutter. Mange oplever en markant og varig effekt allerede efter den allerførste behandling, så de kan nyde de lune sommeraftener uden konstante myggeplager. Skulle effekten aftage, eller er du særligt modtagelig, kan behandlingen nemt gentages.</p>
      <p>Gør sommeren mere behagelig med en hurtig og forebyggende myggebehandling.</p>
    `,
    image: ["https://assets.auxodev.dk/assets/2c4bccc2-b14e-4d92-a991-09327bae6f21/20230518-101339_1.jpg"],
    is_seasonal: true,
    price: "150,00 kr. pr. behandling"
  }
];

// Helper to extract slug string from CMS item
export function getSlug(item) {
  if (!item) return '';
  if (item.page_slug) return item.page_slug;
  if (item.slug) {
    if (typeof item.slug === 'object') {
      return item.slug._ || '';
    }
    return item.slug;
  }
  return '';
}

// Fetch all pages from CMS
export async function fetchPages() {
  try {
    const res = await fetch(`${BASE_URL}/content/pages`);
    if (!res.ok) throw new Error('Failed to fetch pages');
    const data = await res.json();
    return data.length > 0 ? data : FALLBACK_PAGES;
  } catch (error) {
    console.warn('CMS Fetch failed, using fallback pages:', error);
    return FALLBACK_PAGES;
  }
}

// Fetch all treatments from CMS
export async function fetchTreatments() {
  try {
    const res = await fetch(`${BASE_URL}/content/treatments`);
    if (!res.ok) throw new Error('Failed to fetch treatments');
    const data = await res.json();
    return data.length > 0 ? data : FALLBACK_TREATMENTS;
  } catch (error) {
    console.warn('CMS Fetch failed, using fallback treatments:', error);
    return FALLBACK_TREATMENTS;
  }
}

// Fetch a single item by slug
export async function fetchBySlug(slug) {
  try {
    const res = await fetch(`${BASE_URL}/by-slug/${slug}`);
    if (!res.ok) throw new Error(`Failed to fetch slug: ${slug}`);
    const data = await res.json();
    return data;
  } catch (error) {
    console.warn(`CMS Fetch by slug failed for ${slug}, using fallback lookup:`, error);
    const page = FALLBACK_PAGES.find(p => p.page_slug === slug);
    if (page) return { ...page, collectionName: 'pages' };
    const treatment = FALLBACK_TREATMENTS.find(t => t.slug === slug);
    if (treatment) return { ...treatment, collectionName: 'treatments' };
    return null;
  }
}
